export default __webpack_public_path__ + "static/media/ELEMENTOS_14.331262cb.png";